import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISubscriptionPackage } from "models/Subscriptions";
import SubscriptionsAsync from "./subscriptionsAsync";

interface IState {
  subscriptionPackages: ISubscriptionPackage[] | null;
}

const initialState:IState = {
  subscriptionPackages: null,
};

const subscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    setInitialField: <IStateKey extends keyof IState>(state: IState, action: PayloadAction<IStateKey>) => {
      state[action.payload] = initialState[action.payload];
    },
  },
  extraReducers: (builder) => {
    builder
    // Fetch subscription package
    .addCase(SubscriptionsAsync.fetchSubscriptionPackages.fulfilled, (state, action:PayloadAction<ISubscriptionPackage[]>) => {
      state.subscriptionPackages = action.payload;
    })
  }
});

export const SubscriptionsActions = subscriptionsSlice.actions;

export default subscriptionsSlice.reducer;
